import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {BaseCardScratchpadState} from '../../scratchpad/baseCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const setCardDescriptionInputSchema = z.object({
  newDescription: z.string().describe('The new description of the card'),
});

export default function setCardDescriptionTool() {
  async function execute(
    params: ToolExecuteParams<typeof setCardDescriptionInputSchema, BaseCardScratchpadState>,
  ) {
    const {newDescription} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<BaseCardScratchpadState>(agentScratchpad);

    validatedScratchpad.card.description = newDescription;

    return toolResult('Card description set successfully');
  }

  return tool<typeof setCardDescriptionInputSchema, BaseCardScratchpadState>({
    name: V2CardAgentToolName.SetCardDescription,
    description: 'Set the description of the current card',
    displayName: 'Setting card description',
    inputSchema: setCardDescriptionInputSchema,
    execute,
  });
}
